import React, { useState, useEffect } from "react";
import { putApi } from "../../../Services/apiService";
import { toast } from "react-toastify";
import { getFamilyTreeIdFromStorage } from "../../../Utils/headOfLineRole";

const DeclineRecievedInvitationModal = ({ onClose, invitation }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (invitation) {
      console.log("Decline Modal - Invitation object:", invitation);
      console.log("Decline Modal - Available fields:", Object.keys(invitation));
      console.log("Decline Modal - event_id:", invitation.event_id);
      console.log("Decline Modal - id:", invitation.id);
    }
  }, [invitation]);

  const handleConfirmDecline = async () => {
    // Check multiple possible field names for event ID
    const eventId = invitation?.event_id || invitation?.id || invitation?.eventId;
    
    if (!eventId) {
      console.error("Invitation object:", invitation);
      console.error("Available fields:", Object.keys(invitation || {}));
      toast.error("Event ID is missing. Please check console for details.");
      return;
    }

    setLoading(true);
    try {
      const family_tree_id = getFamilyTreeIdFromStorage();
      console.log("Calling API with event ID:", eventId);
      const response = await putApi(
        `/accept-reject-event/${eventId}?family_tree_id=${family_tree_id}`,
        {
          invitation_status: 2,
          note: reason || "",
        }
      );

      console.log("API Response:", response);

      if (response?.statusCode === 200) {
        toast.success(response?.message || "Invitation declined successfully");
        onClose(true);
      } else {
        toast.error(response?.message || "Failed to decline invitation");
      }
    } catch (error) {
      console.error("Error declining invitation:", error);
      console.error("Error response:", error?.response);
      const errorMessage = error?.response?.data?.message || error?.message || "Failed to decline invitation";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };


  const handleChange = (event) => {
    setReason(event.target.value);
  };
  return (
    <>
      <div className="common-modal">
        <div className="modal-header">
          <div className="modal-img"><span> <img src={window.getPublicUrl("/assets/images/decline-icon.svg")} /></span></div>
        <button onClick={onClose} className="close">  <img src={window.getPublicUrl("/assets/images/close.svg")} /></button>
        <h2 className="header-titile mt-3">Decline Invitation</h2>
        </div>
        <div className="modal-body">
          <label className="d-block">Please share a reason why you cannot attend (this will be visible to the host).</label>
          <input
            type="text"
            name="reason"
            id="reason"
             value={reason}
            onChange={handleChange}
              placeholder="I'll be out of town for work"
            className="w-100"
          />
        </div>
      </div>

      {/* =========== Buttons ========== */}
      <div className="modal-button">
        <button onClick={handleConfirmDecline} className="btn btn-decline" disabled={loading}>
          {loading ? "Declining..." : "Confirm Decline"}
        </button>
        <button onClick={() => onClose(true)} className="btn btn-cancel" disabled={loading}>Cancel</button>
      </div>




      {/* <button onClick={onClose}>x</button>
      <div>
        <h2>Decline Invitation</h2>
        <div>
          <label htmlFor="reason">
           Please share a reason why you cannot attend (this will be visible to the host).
          </label>
          <input
            type="text"
            id="reason"
            name="reason"
            value={reason}
            onChange={handleChange}
            placeholder="I'll be out of town for work"
          />
        </div>
      </div>

      <div>
        <button onClick={handleConfirmDecline}>Confirm Decline</button>
        <button onClick={() => onClose(true)}>Cancel</button>
      </div> */}
    </>
  );
};

export default DeclineRecievedInvitationModal;
